<template>
  <div class="table-of-contents-items">
    <div
      v-if="dealerMode && !readOnly && isEditMode"
      class="table-of-contents-wrapper"
    >
      <draggable v-model="tableOfContents">
        <transition-group>
          <IndexItem
            :item="item"
            :key="index"
            :onePageMode="onePageMode"
            :editable="true"
            v-for="(
              item, index
            ) in /*slicedContents(chunk - 1)*/ tableOfContents"
            v-on="{ changePage }"
          />
        </transition-group>
      </draggable>
    </div>
    <div v-else class="table-of-contents-wrapper">
      <IndexItem
        :item="item"
        :key="index"
        :onePageMode="onePageMode"
        :editable="false"
        v-for="(item, index) in /*slicedContents(chunk - 1)*/ tableOfContents"
        v-on="{ changePage }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import draggable from "vuedraggable";

import IndexItem from "@/components/Projects/Playbooks/Index/IndexItem.vue";

export default {
  name: "TableOfContents",
  computed: {
    ...mapState("auth", ["dealerMode"]),
    ...mapState("catalog", ["projectCatalogs"]),
    ...mapGetters("playbook", ["playbookPages"]),
    ...mapGetters("project", ["isEditMode"]),

    /* builds pagination for each sport, starting from page 3 (cover 1, index 2) */
    tableOfContents: {
      get() {
        let pageNumber = 3;
        return this.selectedSports?.map((catalog) => {
          const catalogLength = this.playbookPages?.filter(
            (page) =>
              page?.catalog?.toLowerCase() === catalog?.name?.toLowerCase()
          )?.length;

          const row = {
            pageNumber,
            catalog,
          };

          pageNumber += catalogLength;
          return row;
        });
      },
      set(newValue) {
        //sort items
        this.setIndexOrder({
          sports: newValue.map((val) => {
            return val.sport;
          }),
        });
        //send new sorting to api
        return newValue;
      },
    },

    selectedSports() {
      return this.projectCatalogs.filter((catalog) => {
        //Search if the project has pages with the catalog
        return this.playbookPages.some(
          (page) =>
            page.catalog &&
            page.catalog.toLowerCase() === catalog.name?.toLowerCase()
        );
      });
    },
  },
  methods: {
    ...mapActions("playbook", ["setIndexOrder"]),
    changePage(pageNumber) {
      this.$emit("changePage", pageNumber);
    },
  },
  components: {
    IndexItem,
    draggable,
  },
  props: {
    onePageMode: {
      type: Boolean,
    },
    readOnly: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-of-contents-branding {
  width: 40%;
  margin-right: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.table-of-contents-items {
  display: flex;
  flex-direction: column;
  height: calc(100% - 5.25em);

  .table-of-contents-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100%;
    > div > span {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      width: 100%;
      height: 80%;
      // height: 1em;
    }
  }
}
</style>
